// extracted by mini-css-extract-plugin
export default {"wrapper":"ClanStarsClanResults_wrapper_b2b8e","result":"ClanStarsClanResults_result_ccc7e"};